module.exports = __webpack_public_path__ + "img/p2only.9921452f.png";